import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const staticImagePath = '/static/images/mania';

export interface IStepData {
    id: number,
    info: string,
    txtColor?: COLORS,
    bgColor?: COLORS,
}

export const stepsData: IStepData[] = [
    {
        id: 1,
        info: 'Регистрируетесь в реферальной программе',
    },
    {
        id: 2,
        info: 'Оставляете контакты знакомого, кому хотите посоветовать Дом.ру',
    },
    {
        id: 3,
        info: 'Знакомый подключает Дом.ру и оплачивает услуги на месяц вперёд',
    },
    {
        id: 4,
        info: 'Присылаем вам деньги на карту до 25 числа следующего месяца',
        txtColor: COLORS.Logo,
        bgColor: COLORS.LabelsBg_2,
    },
];

interface IQaData {
    id: number,
    question: string,
    answer: string,
}

export const qaData: IQaData[] = [
    {
        id: 1,
        question: 'Как долго подключаются услуги Дом.ру?',
        answer: 'Подключим Абонента в течение 3 дней с момента его согласия',
    },
    {
        id: 2,
        question: 'Куда поступят деньги?',
        answer: 'Дополни свой профиль реквизитами банковской карты. Выплачиваем вознаграждение на указанную тобой банковскую карту',
    },
];
